"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPError = exports.ErrorBase = exports.isAxiosError = exports.stringifyHTTPTransaction = exports.axiosConfigToHTTPTran = exports.axiosResponseToHTTPTran = void 0;
const jsonOrStr = (o) => {
    return typeof o === "object" ? JSON.stringify(o, null, 2) : String(o);
};
exports.axiosResponseToHTTPTran = (r) => {
    const { data: payload, headers, status, statusText } = r;
    return {
        methodOrStatus: status,
        urlOrStatusText: statusText,
        headers,
        payload,
    };
};
exports.axiosConfigToHTTPTran = (c) => {
    var _a;
    const { method, url, baseURL, headers, data: payload } = c;
    return { methodOrStatus: method, urlOrStatusText: (_a = baseURL !== null && baseURL !== void 0 ? baseURL : "" + url) !== null && _a !== void 0 ? _a : "", headers, payload };
};
exports.stringifyHTTPTransaction = ({ methodOrStatus, urlOrStatusText, headers, payload, }) => {
    return [
        `${String(methodOrStatus || "UNKNOWN").toUpperCase()} ${String(urlOrStatusText)}`,
        ...headersLines(headers),
        "",
        jsonOrStr(payload),
    ]
        .map(s => `  ${s}`)
        .join("\n");
};
const headersLines = (headers) => {
    if (typeof headers === "object") {
        return Object.keys(headers).map(k => `${k}: ${headers[k]}`);
    }
    return [String(headers)];
};
// export const isAxiosResponse = (resp: any): resp is AxiosResponse => {
//     return !!resp["data"]
//     data
//     status
//     statusText
//     headers
//     config
// }
exports.isAxiosError = (err) => {
    return !!err["isAxiosError"];
};
class ErrorBase extends Error {
    constructor(message) {
        super(message); // 'Error' breaks prototype chain here
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    }
    toJSON() {
        return { name: this.name, stack: this.stack };
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
}
exports.ErrorBase = ErrorBase;
class HTTPError extends ErrorBase {
    constructor(message, response) {
        super(message);
        this.message = message;
        this.response = response;
        this.name = "HTTP Error";
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HTTPError);
        }
    }
    static fromAxiosResponse(response) {
        const message = exports.isAxiosError(response) ? response.message : "HTTP Request Failed";
        return new HTTPError(message, response);
    }
    toString() {
        const { name, request, response } = this.toJSON();
        return [
            `${name}: ${this.message}\n`,
            `=== HTTP TRANSACTION ===`,
            exports.stringifyHTTPTransaction(request),
            `---`,
            response ? exports.stringifyHTTPTransaction(response) : "HTTP request failed to send",
        ].join("\n");
    }
    toJSON() {
        let response = undefined;
        if (exports.isAxiosError(this.response)) {
            if (this.response.response) {
                response = exports.axiosResponseToHTTPTran(this.response.response);
            }
            // NOTE: Hole here, not what sure what to do in this case.
        }
        else {
            response = exports.axiosResponseToHTTPTran(this.response);
        }
        return Object.assign(Object.assign({}, super.toJSON()), { request: exports.axiosConfigToHTTPTran(this.response.config), response });
    }
}
exports.HTTPError = HTTPError;
//# sourceMappingURL=errors.js.map